import axios from "axios";

export const solicitarMensajeGuia = ({pedido}) => {


    let data = JSON.stringify({
        "idPedido": pedido.idPedido,
        "estadoPago": pedido.estadoPago
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
       //      url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/04e839fa-fe1e-43a4-a95e-74b28578ebcb', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/04e839fa-fe1e-43a4-a95e-74b28578ebcb',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}